import { useTranslation } from 'react-i18next'

import Spacer from 'components/Spacer'
import Column from 'components/Column'

import Container from './styles'

export default function Footer() {
  const { t } = useTranslation()

  return (
    <Container>
      <Column align="center">
        <img
          className="footer-image"
          src="/assets/images/estrelas_preto.png"
          alt={t('home.guarantee')}
        />
        <p className="guarantee">{t('home.guarantee')}</p>
        <Spacer height={10} />
        <p className="satisfaction">{t('home.satisfaction')}</p>
      </Column>

      <Spacer height={30} />
    </Container>
  )
}
